import { Apollo, Query, gql } from "apollo-angular";
import { Injectable } from "@angular/core";

export type GetUserByCommitteeQuery = {
  getUsersByCommittee: Array<{
    name: String;
  }>;
};

export const GetUserByCommittee = gql`
  query getUsersByCommittee($id: String) {
    getUsersByCommittee(id: $id) {
      name
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GetUserByCommitteeGQL extends Query {
  document = GetUserByCommittee;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}
